import React from 'react';
import {
  Row,
  Col
} from "reactstrap";
import moment from "moment";
import userImage from "../files/user.png";
import doctorImage from "../files/doctor.png";
import { deviceType } from "../constants/general.constant.js";
import getDeviceType from "../helpers/getDeviceTypeHelper.js";

const ProfileHeader = ({ profile, children, imgStyling, noMargin, latestReadingUser,ccmTotalDuration, rpmTotalDuration }) => {

  if (profile) {
    const { fname, lname, isActive, profileImage, isCareProvider, adhenrenceDay, laceRiskScore } = profile;
    const grey = isActive
      ? { ...imgStyling }
      : {
        ...imgStyling,        
        WebkitFilter: "grayscale(100%)",
        filter: "grayscale(100%)"
      };

    function capitalize(cell) {
      if (cell) {
        return cell.charAt(0).toUpperCase() + cell.slice(1);
      }
    }
    const imageDefault = isCareProvider ? doctorImage : userImage;
    const device = getDeviceType();
    return (
      <Row className="align-items-stretch w-100 profile-header-modern">
        <Col xs={12} md={device === deviceType.desktop ? 5 : 6} className="mb-2 mb-md-0 profile-summary-col">
          <div className="profile-summary-card d-flex align-items-center h-100">
            <div className="profile-avatar-status-wrap">
              <img
                style={{ borderRadius: '100%', ...grey }}
                width={50}
                height={50}
                src={profileImage ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + profileImage : imageDefault}
                className="mr-3"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = imageDefault;
                }}
                alt="image"
              />
              <div
                className="mr-3 profile-active-chip"
                style={{
                  backgroundColor: isActive ? '#28a745' : '#dc3545',
                  color: 'white',
                  borderRadius: '18px',
                  padding: '4px 8px',
                  fontSize: '9px',
                  fontWeight: '700',
                  textAlign: 'center',
                  display: 'inline-block',
                  minWidth: '54px',
                  boxShadow: '#1818183D 0px 3px 18px, 0 0 0 2px rgba(255,255,255,0.15)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  border: `2px solid ${isActive ? '#ffffff' : '#ffffff'}`,
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden',
                  textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                }}
              >
                {isActive ? 'Active' : 'Inactive'}
              </div>
            </div>
            <div className="profile-meta-col">
              <div className="profile-card-title">Patient</div>
              <div className="d-flex align-items-center mb-2 profile-meta-item">
                <i className="mdi mdi-account-circle" style={{ color: "#607d8b" }}></i>
                <span className="ml-1 profile-meta-text" style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                  Patient: <span className="font-weight-bold ml-1">{`${capitalize(lname)} ${capitalize(fname)}`}</span>
                </span>
              </div>
              <div className="d-flex align-items-center mb-2 profile-meta-item">
                <i className="mdi mdi-counter" style={{ color: "#607d8b" }}></i>
                <span className="ml-1 profile-meta-text">LACE Score: <span className="font-weight-bold ml-1">{laceRiskScore || "-"}</span></span>
              </div>
              <div className="d-flex align-items-center profile-meta-item">
                <i className="mdi mdi-calendar-check" style={{ color: "#607d8b" }}></i>
                <span className="ml-1 profile-meta-text">
                  Adherence day: <span className="font-weight-bold ml-1">{adhenrenceDay ? adhenrenceDay : 0}</span>
                </span>
              </div>
              {device === deviceType.tablet && <div className="mt-2">
                <i className="mdi mdi-calendar" style={{ color: "#607d8b" }}></i>
                <span className="ml-1 profile-meta-text">
                  Last Reading: <span className="font-weight-bold ml-1">{latestReadingUser && latestReadingUser.deviceReadingDate ? moment(latestReadingUser.deviceReadingDate).format("MMM DD, YYYY") : "NONE"}</span>
                </span>
              </div>}
            </div>
          </div>
        </Col>
        <Col xs={12} md={device === deviceType.desktop ? 4 : 6} className="mb-2 mb-md-0 profile-summary-col">
          <div className="profile-summary-card h-100">
            <div className="profile-card-title">Care Team</div>
            <div className="mb-2 profile-meta-item">
              <i className="mdi mdi-face" style={{ color: "#607d8b" }}></i>
              <span className="ml-1 profile-meta-text">
                Nickname: <span className="font-weight-bold ml-1">{profile && profile.nickname ? profile.nickname : " - "}</span>
              </span>
            </div>
            <div className="mb-2 profile-meta-item">
              <i className="mdi mdi-account" style={{ color: "#607d8b" }}></i>
              <span className="ml-1 profile-meta-text">
                Main Care Provider: <span className="font-weight-bold ml-1">{profile && profile.mainCareProvider && profile.mainCareProvider.fname ? profile.mainCareProvider.fname + " " + profile.mainCareProvider.lname : " - "}</span>
              </span>
            </div>
            <div className="profile-meta-item">
              <i className="mdi mdi-phone" style={{ color: "#607d8b" }}></i>
              <span className="ml-1 profile-meta-text">
                Phone No: <span className="font-weight-bold ml-1">{profile && profile.phone ? profile.phone : " - "}</span>
              </span>
            </div>
            {device === deviceType.tablet && (
              <div className="d-flex align-items-center mt-2">
                <div>
                  <i className="mdi mdi-clock" style={{ color: "#607d8b" }}></i>
                  <span className="ml-1 profile-meta-text">
                    Total RPM: <span className="font-weight-bold ml-1">{rpmTotalDuration ? rpmTotalDuration : "00:00:00"}</span>
                  </span>
                </div>
                <div>
                  <i className="mdi mdi-clock" style={{ color: "#607d8b" }}></i>
                  <span className="ml-1 profile-meta-text">
                    Total CCM: <span className="font-weight-bold ml-1">{ccmTotalDuration ? ccmTotalDuration : "00:00:00"}</span>
                  </span>
                </div>
              </div>
            )}
          </div>
        </Col>
        {device !== deviceType.tablet && <Col xs={12} md={device === deviceType.desktop ? 3 : 6} className="profile-summary-col">
          <div className="profile-summary-card h-100">
            <div className="profile-card-title">Monitoring Stats</div>
            <div className="mb-2 profile-meta-item">
              <i className="mdi mdi-calendar" style={{ color: "#607d8b" }}></i>
              <span className="ml-1 profile-meta-text">
                Last Reading: <span className="font-weight-bold ml-1">{latestReadingUser && latestReadingUser.deviceReadingDate ? moment(latestReadingUser.deviceReadingDate).format("MMM DD, YYYY") : "NONE"}</span>
              </span>
            </div>
            <div className="mb-2 profile-meta-item">
              <i className="mdi mdi-clock" style={{ color: "#607d8b" }}></i>
              <span className="ml-1 profile-meta-text">
                Total RPM: <span className="font-weight-bold ml-1">{rpmTotalDuration ? rpmTotalDuration : "00:00:00"}</span>
              </span>
            </div>
            <div className="profile-meta-item">
              <i className="mdi mdi-clock" style={{ color: "#607d8b" }}></i>
              <span className="ml-1 profile-meta-text">
                Total CCM: <span className="font-weight-bold ml-1">{ccmTotalDuration ? ccmTotalDuration : "00:00:00"}</span>
              </span>
            </div>
          </div>
        </Col>}
      </Row>
    );
  } else {
    return (
      <div >
       
      </div>
    );
  }

};
export default ProfileHeader;
